import { render, staticRenderFns } from "./DotationsAuxAmortissements.vue?vue&type=template&id=54503b16&"
import script from "./DotationsAuxAmortissements.vue?vue&type=script&lang=js&"
export * from "./DotationsAuxAmortissements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports